import { useState, useEffect } from "react";
import { BADGE_DEFS } from "../../constants/badges";

export function BadgeToast({ badges, onDone }) {
  const [idx, setIdx] = useState(0);
  const b = BADGE_DEFS.find(d => d.id === badges[idx]);
  useEffect(() => {
    const t = setTimeout(() => { if (idx + 1 < badges.length) setIdx(i => i + 1); else onDone(); }, 2800);
    return () => clearTimeout(t);
  }, [idx, badges.length, onDone]);
  if (!b) return null;
  return <div className="badge-new"><span style={{ fontSize: "1.4rem" }}>{b.icon}</span><span>Badge unlocked: <strong>{b.label}</strong></span></div>;
}
